import 'jquery-validation'

class ContactForm {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.defineVariables()
    this.initValidation()
    this.bindEvents()
  }

  cacheDOM () {
    this.$form = $( '#contact-form' )
    this.$softwareIssue = $( 'input[name="software_issue"]' )
    this.$kbBody = $( '.knowledge-base-card-body' )
    this.$submitBtn = this.$form.find( 'button[type="submit"]' )

    this.$descField = this.$form.find( 'textarea[name="description"]' )
    this.$descLabel = this.$descField.prev( 'label' )

    this.$adminEmailField = this.$form.find( 'input[name="admin_email"]' )
    this.$adminEmailLabel = this.$adminEmailField.prev( 'label' )

    this.$formGroups = this.$form.find( '.form-group' )
    this.$articles = this.$kbBody.find( 'article' )
    this.$links = this.$kbBody.find( '.out-link' )
    this.$email = this.$form.find( 'input[name="email"]' )
    this.$newsletterOption = $( '#newsletter_option' )

    this.$groupInputs = this.$formGroups.find( 'input, textarea, select' )
  }

  defineVariables () {
    this.lastEmailTested = null
    this.config = {
      license: {
        placeholder: "Describe your issue",
        descLabel: "Issue Description",
        adminLabel: "Account Admin Email"
      },
      general_question: {
        placeholder: "What would you like to ask us?",
        descLabel: "Your Question",
        adminLabel: "Account Admin Email"
      },
      bug: {
        placeholder: "Describe your issue",
        descLabel: "Issue Description",
        adminLabel: "Account Admin Email / Account Email – tied to account"
      }
    }
  }

  initValidation () {
    $.validator.addMethod( "checkCaptcha", function ( value, element ) {
      // grecaptcha.getResponse() returns an empty string if unchecked
      return grecaptcha.getResponse().length > 0
    }, "Please confirm you are not a robot." )

    const $this = this
    // Store the validator instance for reuse
    $this.validator = this.$form.validate( {
      ignore: [], // Validate hidden fields if necessary, but we handle this via :disabled
      invalidHandler: ( event, validator ) => {
        if ( validator.numberOfInvalids() ) {
          const $firstInvalid = $( validator.errorList[ 0 ].element )
          $( 'html, body' ).animate( {
            scrollTop: $firstInvalid.closest( '.form-group' ).offset().top - 100
          }, 100 )

          if ( $firstInvalid.length ) $firstInvalid[ 0 ].focus()
        }
      },
      rules: {
        "g-recaptcha-response": {
          checkCaptcha: true
        },
        is_customer: {
          required: {
            depends: () => this.$softwareIssue.filter( ':checked' ).val() === 'general_question'
          }
        },
        name: "required",
        email: { required: true, email: true },
        admin_email: {
          required: {
            depends: () => this.$softwareIssue.filter( ':checked' ).val() === 'general_question' && this.$form.find( 'input[name="is_customer"]:checked' ).val() === 'yes'
          },
          email: true
        },
        description: { required: true, minlength: 10 },
        software_issue: "required"
      },
      messages: {
        software_issue: "Please select what you need help with.",
        admin_email: "Please enter a valid account administrator email."
      },
      errorPlacement: ( error, element ) => {
        const name = element.attr( "name" )
        if ( name === "software_issue" ) {
          error.insertAfter( ".bug-types" )
        } else if ( name === "is_customer" ) {
          error.insertAfter( element.closest( '.d-flex' ) )
        } else if ( element.attr( "name" ) === "g-recaptcha-response" ) {
          error.appendTo( "#captcha-error" )
        }
        else {
          error.insertAfter( element )
        }
      },
      submitHandler: ( form ) => {
        const formData = $( form ).serialize()

        $.ajax( {
          type: "POST",
          url: "/pages/includes/contact_submit.php",
          data: formData,
          beforeSend: () => {
            this.$submitBtn.text( 'Submitting.....' ).prop( 'disabled', true )
          },
          complete: () => {
            this.$submitBtn.text( 'Submit' ).prop( 'disabled', false )
          },
          success: ( response ) => {
            $( form ).fadeOut( () => {
              $( '.contact-section' ).remove()
              $( '.banner-section.search-section' ).addClass( 'hide' ).html( response.html )
              $( 'html, body' ).animate( { scrollTop: 0 }, 600 )
              $( '.banner-section.search-section' ).removeClass( 'hide' ).addClass( 'active' )
            } )
          },
          error: ( xhr ) => {
            if ( xhr.status == 422 ) {
              let err = {}

              $.each( xhr.responseJSON.errors, function ( i, v ) {
                err[ i ] = v
              } )

              $this.validator.showErrors( err )
            } else {
              alert( "Sorry about that.\rSubmission failed due to an error.\rYou can email me directly support@ajarproductions.com" )
            }
          }
        } )

        return false
      }
    } )
  }

  updateLabelText ( $label, newText ) {
    const nodes = $label.contents()
    if ( nodes.length > 0 && nodes[ 0 ].nodeType === 3 ) {
      nodes[ 0 ].textContent = `${ newText } `
    }
  }

  bindEvents () {
    // Use the label as the primary trigger
    this.$form.on( 'click', '.bug-types label', ( e ) => {
      e.preventDefault() // Stop default browser radio behavior

      const $radio = $( e.currentTarget ).find( 'input[name="software_issue"]' )
      const isAlreadyChecked = $radio.prop( 'checked' )

      // Toggle logic: if it was checked, uncheck it. If not, check it.
      $radio.prop( 'checked', !isAlreadyChecked ).trigger( 'change' )
    } )

    this.$softwareIssue.on( 'change', ( e ) => {
      const $target = $( e.currentTarget )
      const val = $target.is( ':checked' ) ? $target.val() : null

      this.resetConditionalFields()

      if ( !val ) {
        this.toggleActiveStates( false )
        return
      }

      const settings = this.config[ val ]
      this.toggleActiveStates( true, val )

      // UI Updates
      this.$descField.attr( 'placeholder', settings.placeholder )
      this.$descLabel.text( settings.descLabel )
      this.updateLabelText( this.$adminEmailLabel, settings.adminLabel )

      this.validator.resetForm()
    } )

    this.$email.on( 'blur', () => this.checkEmailForSubscription() )
  }

  resetConditionalFields () {
    this.validator.resetForm()

    this.$groupInputs.each( function () {
      const $el = $( this )
      if ( $el.is( ':radio, :checkbox' ) ) {
        $el.prop( 'checked', false )
      } else {
        $el.val( '' )
      }
    } )

    this.$form.find( 'input[type="checkbox"], input[type="radio"]:not([name="software_issue"])' )
      .prop( 'checked', false )
  }

  toggleActiveStates ( isActive, selector = '' ) {
    // Reset all states
    this.$formGroups.removeClass( 'active' ).find( 'input, textarea, select' ).prop( 'disabled', true )
    this.$articles.removeClass( 'active' )
    this.$links.removeClass( 'active' )

    this.$submitBtn.toggleClass( 'active', isActive )
    this.$kbBody.toggleClass( 'active', isActive )

    if ( isActive ) {
      const $activeGroup = this.$formGroups.filter( `.${ selector }` )
      $activeGroup.addClass( 'active' ).find( 'input, textarea, select' ).prop( 'disabled', false )

      this.$articles.filter( `.${ selector }` ).addClass( 'active' )
      this.$links.filter( `.${ selector }` ).addClass( 'active' )
    }
  }

  checkEmailForSubscription () {
    const email = this.$email.val().trim()

    if ( !email || this.lastEmailTested === email ) return

    // Validate email format before bothering the server
    if ( this.validator.element( this.$email ) ) {
      this.lastEmailTested = email

      $.ajax( {
        method: 'POST',
        url: "/pages/includes/ajax.php",
        data: { email, action: 'isActivelySubscribed' },
        dataType: 'json',
        success: ( data ) => {
          const isSubscribed = ( data === true || data === 'true' || data === 1 || data === '1' )

          this.$newsletterOption.toggleClass( 'active', isSubscribed ).find( 'input' ).prop( 'disabled', false )
        },
        error: () => {
          this.$newsletterOption.removeClass( 'active' )
        }
      } )
    }
  }
}

window.ContactForm = ContactForm